"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
exports.CSS = {
    container: 'c-VectorInput',
    inputs: 'c__VectorInput__inputs',
    error: 'c-VectorInput__error',
    leftInput: 'c-VectorInput__leftInput',
    rightInput: 'c-VectorInput__rightInput',
    MDL: {
        error: 'mdl-textfield__error'
    }
};
exports.Style = {
    [exports.CSS.container]: {
        display: 'block'
    },
    [exports.CSS.inputs]: {
        flex: 1,
        display: 'flex',
        'justify-content': 'space-between',
        [`& .${exports.CSS.leftInput}`]: {
            width: '60%'
        },
        [`& .${exports.CSS.rightInput}`]: {
            width: '40%'
        }
    },
    [exports.CSS.error]: {
        visibility: 'visible',
        position: 'relative'
    }
};
//# sourceMappingURL=vector.input.style.js.map